export default "__VITE_ASSET__5f67f1c3__"